export interface CustomerDetails {
  [key: string]: string | boolean | number | null | undefined;
}

export type UpdateCustomerDetailAction = {
  type: 'UPDATE_CUSTOMER_DETAIL';
  payload: CustomerDetails;
};
export type ResetCustomerDetailAction = { type: 'RESET_CUSTOMER_DETAIL'; payload: {} };

export const updateCustomerDetail = (payload: CustomerDetails): UpdateCustomerDetailAction => ({
  type: 'UPDATE_CUSTOMER_DETAIL',
  payload
});
export const resetCustomerDetail = (): ResetCustomerDetailAction => ({
  type: 'RESET_CUSTOMER_DETAIL',
  payload: {}
});
